import React from "react";
import { pagelayout } from "../../../../assets/advertflair";
import styles from "../../../../index.css";

function AdvertflairFooter() {
  const desktopFooter = pagelayout.find(
    (item) => item.name === "desktopFooter"
  ).link;
  const mobileFooter = pagelayout.find(
    (item) => item.name === "mobileFooter"
  ).link;
  return (
    <div>
      <img className="hidden md:flex" src={desktopFooter} alt="" />
      <img className="md:hidden" src={mobileFooter} alt="" />
    </div>
  );
}

export default AdvertflairFooter;
